import { NUMBER } from "../../../constants/app-constants";
import { INVALID_MOBILE_NUMBER, VALID_MOBILE_NUMBER } from "../../../utils/validators/mobile-number-validator";
import { QUESTION_KEYS, QUESTION_LIST } from "./constant";

export const getQuestionList = ({ consent = true, creditReportPhoneError = false }) => {
    const filters = [];
    filters.push(QUESTION_KEYS.LOAN, QUESTION_KEYS.OWNERSHIP);

    if (consent) filters.push(QUESTION_KEYS.CONSENT);
    if (!creditReportPhoneError) filters.push(QUESTION_KEYS.CIBIL);
    return QUESTION_LIST.filter(question => !filters.includes(question.key));
};

export const getOwnerShipQuestion = () => QUESTION_LIST.filter(question =>  question.key === QUESTION_KEYS.OWNERSHIP);

export const mobileNumberValidator = (mobile, partialEncrypted) => {
    if (!partialEncrypted) {
        return VALID_MOBILE_NUMBER.test(mobile) && !INVALID_MOBILE_NUMBER.test(mobile);
    }
    return VALID_MOBILE_NUMBER.test(mobile) &&
           !INVALID_MOBILE_NUMBER.test(mobile) &&
           mobile.slice(-NUMBER.FOUR) === partialEncrypted.slice(-NUMBER.FOUR);
};
